import { IfinalTechnicalReport } from './finalTechnicalReport.types'
import { PDFConfig } from '@/shared/pdf/config'
import { PDFStyles } from '@/shared/pdf/style'
import { Utilities as utils } from '@/shared/utilities'
import { i18n } from "@/plugins/i18n";
import { Locales } from "@/i18n/locales";

import { ApplicationBudget } from '@/entities';
var htmlToPdfMake = require("html-to-pdfmake");

// Define a list of style properties that should not be parsed
var ignoreStyles = { ignoreStyles: ['font-family', 'background-color', 'text-decoration'] };

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class finalTechnicalReport implements IfinalTechnicalReport {

    schema: any = {};
    data: any = {};
    docdefinition: any = {};
    user: string = '';
    currency: string = '';
    id: number;
    excludeKeys :any
    printedDate: string;
    years:any;
    quaters:any;
    docTags: any;
    isStartingPeriod: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    /** Generate pdf file */
    generate(options: any) {
        if (options) {
            this.schema = options.schema;
            this.data = options.data;
            this.docTags= options.docTags;
            this.user = options.user;
            this.id = options.id;
            this.currency = options.currency || "EUR"
            this.printedDate = this.formatDate(new Date());
            this.years=options.years?options.years:0
            this.quaters=options.Quaters?options.Quaters:0
            this.excludeKeys=options.excludeKeys
            this.isStartingPeriod = options.isStartingPeriod
            /** Generate the document content from schema & data */
            this.buildDocDefinition(options.schema, options.data,options.docTags);

            /** Create the pdf file & download */
            pdfMake.createPdf(this.docdefinition).download(`TechnicalReport_${this.data['reportingPeriod']}_${this.data['GrantCode']}.pdf`)

        }
    }

    /** Generate & print pdf document */
    print(schema: any, data: any, docTags:any ,user = '') {
        this.schema = schema;
        this.data = data;
        this.docTags= docTags;
        this.docdefinition = {};
        this.user = user;
        /** Generate the document content from schema & data */
        this.buildDocDefinition(schema, data, docTags);

        /** Create the pdf file & download */
        pdfMake.createPdf(this.docdefinition).download(`iucn_aplication.pdf`)
    }

    buildDocDefinition(schema: any, data: any, docTags:any) {
        /** initialize the content */
        this.docdefinition.content = new Array<any>();

        /** document style css */
        this.docdefinition.styles = PDFStyles.appl;

        /** document page margins */
        this.docdefinition.pageMargins = PDFConfig.pageMargins;

        /** set page header */
        this.setHeader();

        /** set footer of the page */
        this.setFooter(this.user, this.printedDate);

        /** document cover page */
        this.createCoverPage();

        /** table of content */
        this.docdefinition.content.push(this.getTableOfContent());

        /** application data */
        this.buildFromSchema(schema, data, docTags);

    }

    /** set the page header */
    private setHeader() {
        this.docdefinition.header = function (currentPage, pageCount, pageSize) {
            return [
                {
                    columns: [
                        {
                            image: 'data:image/png;base64,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',
                            height: 25,
                            width: 26,
                            margin: 20,
                            alignment: 'left'
                        },
                        {
                            text: 'IUCN Grants Portal',
                            style: ['header3'],
                            margin: [30, 25],
                            alignment: 'left'
                        }
                    ]
                }
            ]
        }
    }

    /** set the page footer */
    private setFooter(user: string, printedDate: string) {
        /** set page footer */
        this.docdefinition.footer = function (currentPage: number, pageCount: number) {
            if (currentPage > 2)
                return [
                    {
                        columns: [
                            {
                                // printed by
                                text: `${i18n.t('Printed by')}  :  ${user}`,
                                fontSize: 8,
                                margin: [20, 3, 0, 0],
                                alignment: 'left'
                            },
                            {
                                // page number
                                text: '-' + currentPage.toString() + '-',
                                fontSize: 6,
                                margin: [0, 3, 0, 0],
                                alignment: 'center'
                            },
                            {
                                // printed date
                                text: `${i18n.t('Printed on')}  :  ${printedDate}`,
                                fontSize: 8,
                                margin: [0, 3, 20, 0],
                                alignment: 'right'
                            }
                        ]
                    }
                ];
        };
    }

    private formatDate(date: any) {
        if (date)
            return utils.formatDate(date);
        else
            return '';
    }

    /** create the cover page */
    private createCoverPage() {

        this.docdefinition.content.push({
            text: `${i18n.t('Project title')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 80, 0, 5],
            alignment: 'center'
        });
        this.docdefinition.content.push({
            text: this.data['Title'],
            style: ['covertext', 'header1']
        });
        this.docdefinition.content.push({
            text: `${i18n.t('Grant code')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });
        this.docdefinition.content.push({
            text: this.data['GrantCode'],
            style: ['covertext', 'coverHeader']
        });
        this.docdefinition.content.push({
            text: `${i18n.t('Period')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });
        this.docdefinition.content.push({
            text: this.data['reportingPeriod'],
            style: ['covertext', 'coverHeader']
        });
        this.docdefinition.content.push({
            text: `${i18n.t('Lead partner')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: this.data['LeadPartner'],
            style: ['covertext', 'coverHeader']
        });

        this.docdefinition.content.push({
            text: `${i18n.t('Start date')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 15, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: this.data['StartDate'] ? this.formatDate(this.data['StartDate']) : '',
            style: ['covertext', 'coverHeader']
        });
        this.docdefinition.content.push({
            text: `${i18n.t('End date')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 5, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: this.data['EndDate'] ? this.formatDate(this.data['EndDate']) : '',
            style: ['covertext', 'coverHeader']
        });

        this.docdefinition.content.push({
            text: `${i18n.t('Project duration')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 5, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: this.data['ProjectDuration'],
            style: ['covertext', 'coverHeader']
        });
        this.docdefinition.content.push({
            text: `${i18n.t('Total project budget')}(${this.currency})`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 15, 0, 5],
            alignment: 'center'
        });

        var totProjectBudget = utils.formatCurrency(this.data['TotalProjectBudget'], this.currency, this.defaultLocale);

        this.docdefinition.content.push({
            text: totProjectBudget.replace(/\u202F/g, " "),
            style: ['covertext', 'coverHeader']
        });
    }

    /** get table of content */
    private getTableOfContent() {
        try {
            return {
                toc: {
                    title: { text: `${i18n.t('Table of Contents')}`, style: ['covertext', 'header1'] }
                },
                pageBreak: 'before'
            };

        } catch (e) {
            console.log(e)
        }
    }

    /** get the application data */
    private buildFromSchema(schema: any, data: any, docTags:any) {
        /** parse main sections */
        Object.keys(schema.properties).forEach((key: string) => {
            if (!(this.excludeKeys.includes(key))) {
                const Datakey=key=="documents"?"esms":key
                const title=schema.properties[key].title
                if (key == 'logFramework') {
                    this.docdefinition.content.push([
                        {
                            canvas: [{ type: 'rect', x: 0, y: 0, w: 760, h: 30, color: '#19719e' }],
                            margin: [0, 0, 0, 20],
                            pageOrientation: 'landscape',
                            pageBreak: 'before'
                        },
                        {
                            text: `${i18n.t(schema.properties[key].title)}`,
                            tocItem: true,
                            style: ['header1'],
                            color: '#fff',
                            relativePosition: { x: 20, y: -45 }
                        }
                    ])
                }
                else if(Datakey == "performance"){
                    this.parseProgress(schema.properties[key],data);
                }
                else if(Datakey == "impact"){
                    this.parseImpact(schema.properties[key],data);
                }
                else if(Datakey == "techDocs"){
                    this.parseTechDocs(schema.properties[key], data, docTags);
                }
                else{
                    this.docdefinition.content.push([
                        {
                            canvas: [{ type: 'rect', x: 0, y: 0, w: 500, h: 30, color: '#19719e' }],
                            pageBreak: 'before',
                            pageOrientation: 'portrait',
                        },
                        {
                            text: `${i18n.t(schema.properties[key].title)}`,
                            tocItem: true,
                            style: ['header1'],
                            color: '#fff',
                            relativePosition: { x: 20, y: -25 }
                        }
                    ]);

                switch (schema.properties[key]['x-display']) {
                    case 'tab':
                        this.parseSubSections(schema.properties[key], data);
                        break;
                    case 'series':
                        this.parseSeriesData(schema.properties[key], data);
                        break;
                    default:
                        schema.properties[key].key = key;
                        this.parseSchemaProps(schema.properties[key], data);
                        break;
                }
            }

            }
        });
    }

    /** parse sub sections(left navigation tabs) */
    private parseSubSections(schema: any, data: any) {
        if(schema['x-class']=="logical-framework"){
            this.parseLogframework(schema, data);
        }
        else{
        /** parse sub sections (left navigation menu) */
        if (schema && schema.properties) {
            Object.keys(schema.properties).forEach((key: string) => {
                    this.docdefinition.content.push({
                        text: `${i18n.t(schema.properties[key].title)}`,
                        style: ['header2']
                    });
                switch (key) {
                    default:
                        if (schema.properties[key].properties) {
                            Object.keys(schema.properties[key].properties).forEach((subkey: string) => {
                                schema.properties[key].properties[subkey].key = subkey;
                                this.parseSchemaProps(schema.properties[key].properties[subkey], data);
                            });
                        }
                        break;
                }
            });
        }
        }
    }

    /** recursive methods to parse schema props and get data from model */
    private parseSchemaProps(schema: any, data: any) {
        switch (schema["x-display"]) {
            case 'fieldset':
                if (schema.properties && schema.dependencies)
                    this.parseDependencies(schema, data)
                else if (schema.properties) {
                    Object.keys(schema.properties).forEach((key: string) => {
                        schema.properties[key].key = key;
                        this.parseSchemaProps(schema.properties[key], data);
                    });
                }
                break;
            case 'group':
                if(schema.title && !schema.hideTitle){
                    this.docdefinition.content.push({
                        text: `${i18n.t(schema.title)}`,
                        style: ['header3']
                    });
                }
                if (schema.properties && schema.dependencies)
                    this.parseDependencies(schema, data)
                else if (schema.properties) {
                    Object.keys(schema.properties).forEach((key: string) => {
                        schema.properties[key].key = key;
                        this.parseSchemaProps(schema.properties[key], data);
                    });
                } else if (schema.type === 'array') {
                    /** parse array props */
                    this.parseArrayProps(schema, data);
                }
                break;
            case 'sub-group':
                if (schema.properties && schema.dependencies){
                    if(schema.title && !schema.hideTitle){
                        this.docdefinition.content.push({
                            text: `${i18n.t(schema.title)}`,
                            style: ['header3']
                        });
                    }
                    this.parseDependencies(schema, data)
                }
                else if (schema.properties)
                    this.parseSubGroupProperties(schema, data);
                else if (schema.type === 'array')
                    this.parseArrayProps(schema, data);
                break;
            default:
                this.parseDataTypes(schema, data);
                break;
        }

    }

    /** parse dependencies */
    parseDependencies(schema: any, data: any) {
        Object.keys(schema.properties).forEach((key: string) => {
            schema.properties[key].key = key;
            this.parseDataTypes(schema.properties[key], data);

            const dep = schema.dependencies[key];

            // cases where dependency does not apply
            if (!dep) return
            if ([null, undefined, '', false].includes(data[key])) return
            if (Array.isArray(data[key]) && data[key].length === 0) return
            if (typeof data[key] === 'object' && Object.keys(data[key]).length === 0) return
            if (dep["x-selectedVal"] && data[key] !== dep["x-selectedVal"]) return

            const dependencies = dep.properties[data[key]] || dep.properties

            Object.keys(dependencies).forEach((key: string) => {
                if(!dependencies[key].key)
                    dependencies[key].key = key;
                this.parseDataTypes(dependencies[key], data);
            });

        });
    }

    /** parse data types (string | number | boolean) */
    private parseDataTypes(schema, data) {
        if (schema.type === 'array') {
            this.parseArrayProps(schema, data);
        }
        else if (schema.type == "object" && schema.key == "submit") {
            this.parseChecklist(schema, data)
        }
        else {
            this.docdefinition.content.push({
                text:`${i18n.t(schema.title)}`,
                style: ['tblheader'],
                margin: [0, 10, 0, 5]
            });

            if(schema.properties){
                Object.keys(schema.properties).forEach(Key=>{
                    this.docdefinition.content.push(
                        {
                            text:`${i18n.t(schema.properties[Key].title)}`,
                        style: ['header3'],
                        margin: [0, 5, 0, 10]
                        }
                    )
                    this.docdefinition.content.push(
                        this.formatProps(schema.properties[Key],data[Key])
                    );
                })
            }
            else{
            this.docdefinition.content.push(
                this.formatProps(schema, data[schema['key']])
            );
            }
        }
    }

    /** format the properties based on the type */
    formatProps(schema: any, data: any) {
        if (schema.format === 'currency') {
            // TO DO: fixed in ES
            var finalData = utils.formatCurrency(data, this.currency, this.defaultLocale);
            return finalData.replace(/\u202F/g, " ");
        }
        if (schema.contentMediaType) {
            if(data){
            return { text: `${i18n.t(data.name)}`, link: `${process.env.VUE_APP_Base_URL}/download/document/${data.uploadedFileName}`,color:'blue',decoration:'underline'}
            }
            else{
                return {}
            }
        }
        if (schema.type === 'boolean') {
            return data ? `${i18n.t('Yes')}` : `${i18n.t('No')}`
        }
        if ((schema.type === 'string' && schema.maxLength > 1000)) {
            return data ? htmlToPdfMake(data, ignoreStyles) : ''
        }
        return (data || '');
    }

    /** parse arrays */
    private parseArrayProps(schema: any, data: any) {
        var body = [];
        body.push([{ text: `${i18n.t(schema.title)}`, colSpan: 2, style: ['tblheader'] }, {}]);
        const arr = data[schema['key']];

        if (arr && arr.length > 0) {
            let index = 1;
            arr.forEach((val: any) => {

                if (schema.items && schema.items.properties) {
                    Object.keys(schema.items.properties)
                        .forEach((key: string) => {
                            const subSchema = schema.items.properties[key];
                            if (subSchema.type === 'string' && subSchema.maxLength > 1000) {
                                body.push([{ text: `${i18n.t(subSchema.title)}`, colSpan: 2, style: ['tbltitle'] }, {}]);
                                body.push([{ stack: [val[key] ? htmlToPdfMake(val[key], ignoreStyles) : ''], colSpan: 2, style: ['tblcell'] }, {}]); //Bug #292074
                            } 
                            else if(subSchema['properties']&&subSchema["x-display"]&&subSchema["x-display"]=="optional-input"){
                                Object.keys(subSchema['properties']).forEach(key2=>{
                                    if(subSchema.properties[key2].type=="number"){
                                        body.push([
                                            { text:`${i18n.t(subSchema.properties[key2].title)}`,style: ['tbltitle'] },
                                            { text:`${this.formatProps(subSchema, val[key][key2])}%`,style: ['tblcell'] }
                                        ]);
                                    }
                                })
                            }
                            else {
                                body.push([
                                    { text: `${i18n.t(subSchema.title)}`, style: ['tbltitle'] },
                                    { text: this.formatProps(subSchema, val[key]), style: ['tblcell'] }
                                ]);
                            }
                        });
                }

                /** add separator row b/w the array items */
                if (index !== arr.length)
                    body.push([{ text: '', colSpan: 2, style: ['tblcell'] }, {}]);

                index += 1;
            });
        }

        this.docdefinition.content.push({
            table: {
                widths: ['40%', '60%'],
                body,
                margin: [0, 10, 0, 10]
            },
            /** set table layout */
            layout: {
                hLineWidth: function (i: number, node: any) {
                    return (i == 0) ? 0.1 : 0.4;
                },
                vLineWidth: function (i: number, node: any) {
                    return (i == 1) ? 0.4 : 0.1;
                },
                hLineColor: function (i: number, node: any) {
                    return (i == 0) ? 'gray' : 'black';
                },
                vLineColor: function (i: number, node: any) {
                    return (i == 1) ? 'black' : 'gray';
                },
                paddingTop: function (i: number, node: any) { return 5; },
                paddingBottom: function (i: number, node: any) { return 5; }
            },

            margin: [0, 10, 0, 10]
        });

    }
    parseArrayPropssubProp(schema: any, data: any,DataKey=null) {
        var body = [];
        body.push([{ text: `${i18n.t(schema.title)}`, colSpan: 2, style: ['tblheader'] }, {}]);
        const arr = data;
        if (arr && arr.length > 0) {
            let index = 1;
            arr.forEach((val: any) => {

                if (schema.items && schema.items.properties) {
                    Object.keys(schema.items.properties)
                        .forEach((key: string) => {
                            const subSchema = schema.items.properties[key];
                            if (subSchema.type === 'string' && subSchema.maxLength > 1000) {
                                body.push([{ text: `${i18n.t(subSchema.title)}`, colSpan: 2, style: ['tbltitle'] }, {}]);
                                body.push([{ stack: [val[key] ? htmlToPdfMake(val[key], ignoreStyles) : ''], colSpan: 2, style: ['tblcell'] }, {}]); //Bug #292074
                            }
                            else if(subSchema['properties']&&subSchema["x-display"]&&subSchema["x-display"]=="optional-input"){
                                Object.keys(subSchema['properties']).forEach(key2=>{
                                    if(subSchema.properties[key2].type=="number"){
                                        body.push([
                                            { text:`${i18n.t(subSchema.properties[key2].title)}`,style: ['tbltitle'] },
                                            { text:`${this.formatProps(subSchema, val[key][key2])}%`,style: ['tblcell'] }
                                        ]);
                                    }
                                })
                            }
                            else {
                                body.push([
                                    { text: `${i18n.t(subSchema.title)}`, style: ['tbltitle'] },
                                    { text: this.formatProps(subSchema, val[key]), style: ['tblcell'] }
                                ]);
                            }
                        });
                }

                /** add separator row b/w the array items */
                if (index !== arr.length)
                    body.push([{ text: '', colSpan: 2, style: ['tblcell'] }, {}]);

                index += 1;
            });
        }

        this.docdefinition.content.push({
            table: {
                widths: ['40%', '60%'],
                body,
                margin: [0, 10, 0, 10]
            },
            /** set table layout */
            layout: {
                hLineWidth: function (i: number, node: any) {
                    return (i == 0) ? 0.1 : 0.4;
                },
                vLineWidth: function (i: number, node: any) {
                    return (i == 1) ? 0.4 : 0.1;
                },
                hLineColor: function (i: number, node: any) {
                    return (i == 0) ? 'gray' : 'black';
                },
                vLineColor: function (i: number, node: any) {
                    return (i == 1) ? 'black' : 'gray';
                },
                paddingTop: function (i: number, node: any) { return 5; },
                paddingBottom: function (i: number, node: any) { return 5; }
            },

            margin: [0, 10, 0, 10]
        });
        }

    /** parse sub group properties */
    private parseSubGroupProperties(schema: any, data: any) {
        var body = [];
        if(schema.title && !schema.hideTitle){
        body.push([{ text: `${i18n.t(schema.title)}`, colSpan: 2,style:['tblheader']}, {}])
        this.docdefinition.content.push({
            table: {
                widths: ['40%', '60%'],
                body,
                margin: [10,0, 0,0]
            }})
            body=[]
        }
        Object.keys(schema.properties).forEach((key: string) => {
            if (schema.properties[key].format && schema.properties[key].format === "date") {
                body.push([
                    { text: `${i18n.t(schema.properties[key].title)}`, style: 'tbltitle' },
                    { text: this.formatDate(data[key]), style: 'tblcell' }
                ]);
            }
            else if (schema.properties[key]["x-display"] == "fieldset") {
                this.parseSchemaProps(schema.properties[key], data)
            }
            else if (schema.properties[key].type == "boolean") {

            }
            else if (schema.properties[key].type == "array") {
                this.parseArrayPropssubProp(schema.properties[key], data[key])
            }
            else if (schema.properties[key].type == "string") {
                body.push([
                    { text: `${i18n.t(schema.properties[key].title)}`, style: 'tbltitle' },
                    { stack: [data[key] == undefined ? "" : htmlToPdfMake(data[key], ignoreStyles)], style: 'tblcell' }
                ]);
            }
            else if (schema.properties[key].contentMediaType) {
                body.push([{ text: `${i18n.t(schema.properties[key].title)}`, style: 'tbltitle' },
                { text: data[key] ? `${i18n.t(data[key].name)}` : "", link: `${process.env.VUE_APP_Base_URL}/download/document/${data[key] ? data[key].uploadedFileName : ""}`, color: 'blue', decoration: 'underline' }])
            }
            else if (schema.properties[key].properties) {
                if (data["formalProductsDocuments"]) {
                    data["formalProductsDocuments"].forEach(x =>
                        body.push([{ text: `${i18n.t(schema.properties[key].properties.formalProductsDocuments.title)}`, style: 'tbltitle' },
                        { text: x.formalProductsDoc ? `${i18n.t(x.formalProductsDoc.name)}` : '', link: `${process.env.VUE_APP_Base_URL}/download/document/${x.formalProductsDoc ? x.formalProductsDoc.uploadedFileName : ""}`, color: 'blue', decoration: 'underline' }]))
                }
            }
            else {
                body.push([
                    { text: `${i18n.t(schema.properties[key].title)}`, style: 'tbltitle' },
                    { text: data[key], style: 'tblcell' }
                ]);
            }
        });
        if(body.length>0){
        this.docdefinition.content.push({
            table: {
                widths: ['50%','50%'],
                body,
                margin: [0, 0, 0, 10]
            },
            /** set table layout */
            layout: {
                hLineWidth: function (i: number, node: any) {
                    return (i == 0) ? 0.1 : 0.4;
                },
                vLineWidth: function (i: number, node: any) {
                    return (i == 1) ? 0.4 : 0.1;
                },
                hLineColor: function (i: number, node: any) {
                    return (i == 0) ? 'gray' : 'black';
                },
                vLineColor: function (i: number, node: any) {
                    return (i == 1) ? 'black' : 'gray';
                },
                paddingTop: function (i: number, node: any) { return 5; },
                paddingBottom: function (i: number, node: any) { return 5; }
            },

            margin: [0, 10, 0, 10]
        });
    }
    }
    /** custom method to parse budget data */
    private parseSeriesData(schema: any, data: any) {
        this.docdefinition.content.push({margin:[20,10,0,10],text:`${i18n.t('Download Budget')}`,link: process.env.VUE_APP_API_Base_URL + `api/Budget/DownloadBudgetExcel/${this.id}`,color:"blue",bold:true,decoration:'underline'})
    }

    parseChecklist(schema: any, data: any) {
        let checkListColumns = []
        let checklistDocs = []
        let additionalDocs = []
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        Object.keys(schema['properties']).forEach(key1 => {
            Object.keys(schema['properties'][key1]['properties']).forEach(key2 => {
                this.docdefinition.content.push({
                    fontSize: 15,
                    bold: true, text: `${i18n.t(schema['properties'][key1]['properties'][key2].title)}`, margin: [0, 15, 0, 5]
                })
                if (schema['properties'][key1]['properties'][key2].type == "object") {
                    Object.keys(schema['properties'][key1]['properties'][key2]['properties']).forEach(key3 => {
                        if (schema['properties'][key1]['properties'][key2]['properties'][key3].type == "object") {
                            Object.keys(schema['properties'][key1]['properties'][key2]['properties'][key3]['properties']).forEach(key4 => {
                                this.docdefinition.content.push({ margin: [0, 5, 0, 5], fontSize: 15, width: 'auto', text: `${i18n.t(schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4].title)}` })
                                if (data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]]) {
                                    if (key4 == "locationMapExists" && validImageTypes.includes(data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]]['type'])) {
                                        checklistDocs.push({ margin: [5, 0, 0, 5], text: `${i18n.t(data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]].name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]].uploadedFileName}`,color:'blue',decoration:'underline'})
                                    }
                                    else {
                                        checklistDocs.push({ margin: [5, 0, 0, 5], text: `${i18n.t(data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]].name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${data[schema['properties'][key1]['properties'][key2]['properties'][key3]['properties'][key4]["x-doc-key"]].uploadedFileName}`,color:'blue',decoration:'underline'})
                                    }
                                    this.docdefinition.content.push({ ul: checklistDocs });
                                    checklistDocs = [];
                                }else if(key4 === "staffCVExists" && data.keyProjectStaff.length>0) { //Bug #292074
                                    checklistDocs.push({ margin: [5, 0, 0, 5], text:`${i18n.t(data.keyProjectStaff[0].staffCV.name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${data.keyProjectStaff[0].staffCV.uploadedFileName}` , color:'blue',decoration:'underline'});
                                }
                                this.docdefinition.content.push({ ul: checklistDocs });
                                checklistDocs = [];
                            })
                        }
                        else {
                            checkListColumns.push({ fontSize: 15, width: 'auto', text: `${i18n.t(schema['properties'][key1]['properties'][key2]['properties'][key3].title)}` })
                            this.docdefinition.content.push({ margin: [0, 5, 0, 5], columns: checkListColumns })
                            checkListColumns = []
                            let Multidocs = schema['properties'][key1]['properties'][key2]['properties'][key3].type == "array" ? schema['properties'][key1]['properties'][key2]['properties'][key3]["x-doc-key"].split("[")[0] : schema['properties'][key1]['properties'][key2]['properties'][key3]["x-doc-key"]
                            if (data[Multidocs]) {
                                if (schema['properties'][key1]['properties'][key2]['properties'][key3].type == "array") {
                                    data[Multidocs].forEach(docs => {
                                        checklistDocs.push({ margin: [5, 0, 0, 5], text: `${i18n.t(docs.document.name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${docs.document.uploadedFileName}`,color:'blue',decoration:'underline'})
                                    });
                                    this.docdefinition.content.push({ ul: checklistDocs })
                                    checklistDocs = []
                                }
                                else {
                                    checklistDocs.push({ margin: [5, 0, 0, 5], text: `${i18n.t(data[Multidocs].name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${data[Multidocs].uploadedFileName}`,color:'blue',decoration:'underline'})
                                    this.docdefinition.content.push({ ul: checklistDocs })
                                    checklistDocs = []
                                }

                            }
                        }
                    })
                }
                else {
                    if (data['additionalDocs']) {
                        data['additionalDocs'].forEach(docs => {
                            if (docs.documentId) {
                                additionalDocs.push({ text: `${i18n.t(docs.name)}`, link: process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${docs.uploadName}`,color:'blue',decoration:'underline'})
                            }
                        });
                        this.docdefinition.content.push({ margin: [5, 0, 0, 5], ul: additionalDocs })
                        additionalDocs = []
                    }
                }
            })
        })
    }
    private parseImpact(schema: any, data: any) {
        this.docdefinition.content.push([
            {
                canvas: [{ type: 'rect', x: 0, y: 0, w: 760, h: 30, color: '#19719e' }],
                margin: [0, 0, 0, 20],
                pageOrientation: 'landscape',
                pageBreak: 'before'
            },
            {
                text:`${i18n.t('Impact Reporting')}` ,
                tocItem: true,
                style: ['header1'],
                color: '#fff',
                relativePosition: { x: 20, y: -45 }
            }
        ])
        this.docdefinition.content.push({
            text: `${i18n.t('Impact Report')}`,
            style: ['header2'],
        });
        if(data['monitoringPlan'].length>0){
            let ImpactData=this.parseImpactReport(data['monitoringPlan'])
            let impactDataTable=this.MakeImpactTable(ImpactData)
            this.docdefinition.content.push({
                layout: 'lightHorizontalLines',
                table: {
                    headerRows: 1,
                    widths: this.isStartingPeriod ? ['25%', '25%', '25%','25%'] : ['25%', '25%', '24%','13%','13%'],
                    body: impactDataTable
                },
            });
        }
    }
    private parseProgress(schema,data)
    {
        this.docdefinition.content.push([
            {
                canvas: [{ type: 'rect', x: 0, y: 0, w: 760, h: 30, color: '#19719e' }],
                margin: [0, 0, 0, 20],
                pageOrientation: 'landscape',
                pageBreak: 'before'
            },
            {
                text:`${i18n.t('Project Performance')}` ,
                tocItem: true,
                style: ['header1'],
                color: '#fff',
                relativePosition: { x: 20, y: -45 }
            }
        ])
        this.docdefinition.content.push({
            text: `${i18n.t('Project Performance')}`,
            style: ['header2'],
        });
        if(data['performanceReport'].length>0)
        {
            let progressData=this.parseProgressData(schema, data['performanceReport'])
            let progressTable=this.MakeProgressDataTable(progressData)
            let progerssHeaderWidth=this.calculateHeaderWidth()
            this.docdefinition.content.push({
                layout: 'lightHorizontalLines',
                table: {
                    headerRows: 1,
                    widths:progerssHeaderWidth ,
                    body: progressTable
                },
            });
        }
    }
    private parseTechDocs(schema: any, data: any, docTags:any) {
        this.docdefinition.content.push([
            {
                canvas: [{ type: 'rect', x: 0, y: 0, w: 500, h: 30, color: '#19719e' }],
                pageBreak: 'before',
                pageOrientation: 'portrait',
            },
            {
                text: `${i18n.t(schema.title)}`,
                tocItem: true,
                style: ['header1'],
                color: '#fff',
                relativePosition: { x: 20, y: -25 }
            }
        ]);
        var body = [];
        body.push([{ text: `${i18n.t('Additional documents')}`, colSpan: 3, style: ['tblheader'] }, {}, {}]);
        if (data['techReportDocuments']) {
            data['techReportDocuments'].forEach(docs => {
                if (docs.documentId) {
                    var TagDetail = docTags.find(tag => tag.DocumentTagId == docs.docType);
                    const documentDetails = [
                        { text: docs.docType ? `${i18n.t(TagDetail.TagName)}` : "", style: ['tblcell'] },
                        { text: docs.description ? `${i18n.t(docs.description)}` : "", style: ['tblcell'] ,color: 'black' },
                        { text: `${i18n.t(docs.name)}`, link: `${process.env.VUE_APP_Base_URL}/download/document/${docs.uploadedFileName}`, color: 'blue', decoration: 'underline', style: ['tblcell'] },
                    ];
                    body.push(documentDetails);
                }
            });
        }
        this.docdefinition.content.push({
            table: {
                widths: ['20%', '20%','60%'],
                body,
                margin: [0, 10, 0, 10]
            },
            /** set table layout */
            layout: {
                hLineWidth: function (i: number, node: any) {
                    return (i == 0) ? 0.1 : 0.4;
                },
                vLineWidth: function (i: number, node: any) {
                    return (i == 1) ? 0.4 : 0.1;
                },
                hLineColor: function (i: number, node: any) {
                    return (i == 0) ? 'gray' : 'black';
                },
                vLineColor: function (i: number, node: any) {
                    return (i == 1) ? 'black' : 'gray';
                },
                paddingTop: function (i: number, node: any) { return 5; },
                paddingBottom: function (i: number, node: any) { return 5; }
            },

            margin: [0, 10, 0, 10]
        });
    }
    calculateHeaderWidth()
    {
        let widthArray=[]
        let length= Object.keys(this.schema.properties['performance'].properties).length
        let columnWidth=`${Math.round(100/length)}%`
        for(let i=1;i<=length;i++)
        {
            widthArray.push(columnWidth)
        }
        return widthArray
    }
    parseProgressData(schema, data)
    {
      let resultCount=0
      let progressData={}
      data.forEach(element => {
        let resultData={}
        resultCount=resultCount+1
        let optionsCount=0
          let result=`R${resultCount}-${element.description}`
          progressData[result]={}
          progressData[result]['result']=result
          progressData[result]['activities']={}
                progressData[result]['progress']=this.mapProgress(schema.properties.progress.items, String(element.progress))
                element.deliverables.forEach(output => {
                    optionsCount=optionsCount+1
                    let activityCount=0
                    output.activities.forEach(element => {
                        activityCount=activityCount+1
                        let activityName=`A${resultCount}.${optionsCount}.${activityCount} ${element.description}`
                        progressData[result]['activities'][activityName]={}
                        progressData[result]['activities'][activityName]['result']=activityName
                        progressData[result]['activities'][activityName]['progress']=element.progress
                        progressData[result]['activities'][activityName]['plans']=element.plans
                        progressData[result]['activities'][activityName]['challengesOrImpact']=element.challengesOrImpact
                    });
                  });
            progressData[result]['plans']=element.plans
            progressData[result]['challengesOrImpact']=element.challengesOrImpact
      });
      return progressData
    }
    mapProgress(mapItems, id)
    {
       let progress=""
    //    let map={
    //        '1':"Achived",
    //        '2':"Partialy Achived",
    //        '3':"In progress",
    //        '4':"Not Achived"
    //    }
      mapItems.forEach(item=> {
           if(item.value == id)
           {
             progress=item.label
           }
       }); 
       return progress;
    }
    MakeProgressDataTable(data)
    {   
        let tableData = []
        let insideTable = []
        let HeadersArray=[]
        Object.keys(this.schema.properties['performance'].properties).forEach(header => {
            insideTable.push({text:`${i18n.t(this.schema.properties['performance'].properties[header].title)}`})
            HeadersArray.push(header)
        });
        tableData.push(insideTable)
        insideTable=[]
          Object.keys(data).forEach(key=>{
            Object.keys(data[key]).forEach(keys=>{
                HeadersArray.forEach(header => {
                    if(header==keys)
                    {
                        insideTable.push({text:`${i18n.t(data[key][keys])}`})
                    }
                })
            })
            tableData.push(insideTable)
            insideTable=[]
            Object.keys(data[key]['activities']).forEach(info=>{
                Object.keys(data[key]['activities'][info]).forEach(activityInfo=>{
                 HeadersArray.forEach(header => {
                    if(header==activityInfo)
                    {
                        insideTable.push({text:`${i18n.t(data[key]['activities'][info][activityInfo])}`})
                    }
                })
            })
            tableData.push(insideTable)
            insideTable=[]
        })
            })
        return tableData
    }
    MakeImpactTable(transformedData)
    {

        let tableData = []
        let insideTable = []
        let tableColumns = ['Indicators', {key:'BaseLine', text:`${i18n.t('Baseline')}`,alignment:'center'}, {key:'Target', text:`${i18n.t('Target')}`,alignment:'center'}]
        if(!this.isStartingPeriod){
            tableColumns.push({key:'PreviousValue', text:`${i18n.t('Value Preceding Period')}`,alignment:'center'},{key:'Value', text:`${i18n.t('Value Current Period')}`,alignment:'center'});
        }
        else{
            tableColumns.push({key:'Value', text:`${i18n.t('Value')}`,alignment:'center'});
        }
        tableData.push(tableColumns);
        let noOfColumns = tableData[0].length;
            Object.keys(transformedData).forEach(key1=>{
            insideTable.push({text:`${i18n.t(key1)}`,colSpan: noOfColumns})
            for(let i = 0; i < noOfColumns-1; i++){
                insideTable.push({text:""})
            }
            tableData.push(insideTable)
            insideTable = []
            Object.keys(transformedData[key1]).forEach(key2 => {
                    if(transformedData[key1][key2]['hasChildrens']){
                    insideTable.push({ text: `${i18n.t(key2)}`, margin: [10, 0, 0, 0], colSpan: noOfColumns  })
                    for(let i = 0; i < noOfColumns-1; i++){
                        insideTable.push({text:""})
                    }
                    tableData.push(insideTable)
                    insideTable = []
                    Object.keys(transformedData[key1][key2]).forEach(key3 => {
                        if (typeof transformedData[key1][key2][key3] === 'object') {
                            if (key3 == 'Sites' && Object.keys(transformedData[key1][key2][key3]).length > 0) {
                                Object.keys(transformedData[key1][key2][key3]).forEach(site => {
                                    insideTable.push({ text: `${i18n.t(site)}`, margin: [15, 0, 0, 0], colSpan: noOfColumns })
                                    for(let i = 0; i < noOfColumns-1; i++){
                                        insideTable.push({text:""})
                                    }
                                    tableData.push(insideTable)
                                    insideTable = []
                                    Object.keys(transformedData[key1][key2][key3][site]).forEach(Indicator => {
                                        insideTable.push({ text: `${i18n.t(Indicator)}`, margin: [20, 0, 0, 0] });
                                        for(let i = 1; i < tableColumns.length; i++){
                                            insideTable.push({ text: `${i18n.t(transformedData[key1][key2][key3][site][Indicator][tableColumns[i]['key']])}`, alignment: 'center' })
                                        }
                                        tableData.push(insideTable)
                                        insideTable = []
                                        Object.keys(transformedData[key1][key2][key3][site][Indicator]).forEach(key6 => {
                                            if (key6 === 'Levels' &&Object.keys(transformedData[key1][key2][key3][site][Indicator][key6]).length > 0) {
                                                Object.keys(transformedData[key1][key2][key3][site][Indicator][key6]).forEach(key7 => {
                                                    if ( Object.keys(transformedData[key1][key2][key3][site][Indicator][key6][key7]).length > 0) {
                                                        insideTable.push({ text: `${i18n.t(key7)}`, margin: [30, 0, 0, 0] });
                                                        for (let i = 1; i < tableColumns.length; i++) {
                                                            insideTable.push({ text: `${i18n.t(transformedData[key1][key2][key3][site][Indicator][key6][key7][tableColumns[i]['key']])}`, alignment: 'center' });
                                                        }
                                                        tableData.push(insideTable);
                                                        insideTable = [];
                                                    }
                                                });
                                            }
    
                                        })
                                       
                                    })
                                })
                            }
                            else if (key3 != 'Sites') {
                                let index = 1;
                                if (transformedData[key1][key2][key3]['BaseLineunknown']) {
                                    insideTable.push({ text: `${i18n.t(key3)}`, margin: [20, 0, 0, 0]}, { text: 'N/A', alignment: 'center' });
                                    index = 2
                                } else {
                                    insideTable.push({ text: `${i18n.t(key3)}`, margin: [20, 0, 0, 0]});
                                }
                                
                                    for(let i = index; i < tableColumns.length; i++){
                                        insideTable.push({ text: `${i18n.t(transformedData[key1][key2][key3][tableColumns[i]['key']])}`, alignment: 'center' })
                                    }
                                    tableData.push(insideTable)
                                    insideTable = []
                            }
                           
                                Object.keys(transformedData[key1][key2][key3]).forEach(key4 => {
                                    if (key4 === 'Levels' &&Object.keys(transformedData[key1][key2][key3][key4]).length > 0) {
                                        Object.keys(transformedData[key1][key2][key3][key4]).forEach(key5 => {
                                            if ( Object.keys(transformedData[key1][key2][key3][key4][key5]).length > 0) {
                                                insideTable.push({ text: `${i18n.t(key5)}`, margin: [30, 0, 0, 0] });
                                                for (let i = 1; i < tableColumns.length; i++) {
                                                    insideTable.push({ text: `${i18n.t(transformedData[key1][key2][key3][key4][key5][tableColumns[i]['key']])}`, alignment: 'center' });
                                                }
                                                tableData.push(insideTable);
                                                insideTable = [];
                                            }
                                        });
                                    }
                                });
                            
                            
                        }
                        /*insideTable.push({text:""},{text:""},{text:""},{text:""})
                        tableData.push(insideTable)
                        insideTable = []*/
                    })
                }
                else {
                    insideTable.push({ text: `${i18n.t(key2)}`, margin: [10, 0, 0, 0] });
                    for(let i = 1; i < tableColumns.length; i++){
                        insideTable.push({ text: transformedData[key1][key2][tableColumns[i]['key']] ? `${i18n.t(transformedData[key1][key2][tableColumns[i]['key']])}` : '', alignment: 'center' })
                    }
                    tableData.push(insideTable)
                    insideTable = [] 
                }
            })
        })
        return tableData;
    }
    parseImpactReport(monitoringPlan)
    {
       let count=0
       let impactData={}
       monitoringPlan.forEach(data=> {
           count=count+1
           let Result=`R${count}-${data.Description}`
           impactData[Result]={}
           data.indicators.forEach(indicators => {
            let IndicatorId=`${indicators.Code}-${indicators.Description}`
            impactData[Result][IndicatorId]={}
            impactData[Result][IndicatorId]['Sites']={}
               if (indicators.Measures) {
                   impactData[Result][IndicatorId]['hasChildrens'] = true;
                   indicators.Measures.forEach(values => {
                       impactData[Result][IndicatorId][`${values.Description}`] = {}
                       if (values.Levels) {
                           impactData[Result][IndicatorId][`${values.Description}`]['hasChildrens'] = true;
                           values.Levels.forEach(level => {
                               if (!impactData[Result][IndicatorId][`${values.Description}`]['Levels']) {
                                   impactData[Result][IndicatorId][`${values.Description}`]['Levels'] = {};
                               }
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`] = {};
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`]['BaseLine'] = level.Baseline;
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`]['BaseLineunknown'] = level.Baselineunknown;
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`]['Target'] = level.Target;
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`]['PreviousValue'] = level.PreviousValue;
                               impactData[Result][IndicatorId][`${values.Description}`]['Levels'][`${level.Description}`]['Value'] = level.Value;
                           });
                       }
                       else {
                           impactData[Result][IndicatorId][`${values.Description}`]['BaseLine'] = values.Baseline
                           impactData[Result][IndicatorId][`${values.Description}`]['BaseLineunknown'] = values.Baselineunknown
                           impactData[Result][IndicatorId][`${values.Description}`]['Target'] = values.Target
                           impactData[Result][IndicatorId][`${values.Description}`]['PreviousValue'] = values.PreviousValue
                           impactData[Result][IndicatorId][`${values.Description}`]['Value'] = values.Value
                       }
                   });
               }
            else if(indicators.Sites)
            {
                impactData[Result][IndicatorId]['hasChildrens'] = true;
                indicators.Sites.forEach(siteData=>{
                    impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`]={}
                    siteData.Measures.forEach(values => {
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]={}
                        if(values.Levels){
                            impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['hasChildrens'] = true;
                         values.Levels.forEach(level => {
                               if (! impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels']) {
                                impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'] = {};
                               }
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`] = {};
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`]['BaseLine'] = level.Baseline;
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`]['BaseLineunknown'] = level.Baselineunknown;
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`]['Target'] = level.Target;
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`]['PreviousValue'] = level.PreviousValue;
                               impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Levels'][`${level.Description}`]['Value'] = level.Value;
                           });

                        }
                        else{
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['BaseLine']=values.Baseline
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['BaseLineunknown']=values.Baselineunknown
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Target']=values.Target
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['PreviousValue']=values.PreviousValue
                        impactData[Result][IndicatorId]['Sites'][`Site - ${siteData.Description}`][`${values.Description}`]['Value']=values.Value
                     } });
                })
            }
            else {
                impactData[Result][IndicatorId]['hasChildrens'] = false;
                impactData[Result][IndicatorId]={}
                impactData[Result][IndicatorId]['BaseLine']=indicators.Baseline
                impactData[Result][IndicatorId]['BaseLineunknown']=indicators.Baselineunknown
                impactData[Result][IndicatorId]['Target']=indicators.Target
                impactData[Result][IndicatorId]['PreviousValue']=indicators.PreviousValue
                impactData[Result][IndicatorId]['Value']=indicators.Value
            }
           });
       });
     return impactData
    }

    /** custom method to parse log framework */
    private parseLogframework(schema: any, data: any) {
        this.docdefinition.content.push({
            text: `${i18n.t('LOGICAL FRAMEWORK')}`,
            style: ['header2']
        });
        if (data['logframework'].length > 0) {
            this.docdefinition.content.push(
                { text: `${i18n.t('Project Overall Objective')}`, margin: [0, 4], color: 'grey', fontSize: '10' },
                { text: data['projectOverallObjective'], margin: [0, 18], color: 'black', fontSize: '10' });

            let monitoringPlan = this.parseLogframeworkData(data['logframework']);
            let lfTable = this.makeTable(monitoringPlan);

            this.docdefinition.content.push({
                layout: 'lightHorizontalLines',
                table: {
                    headerRows: 1,
                    widths: ['33.3%', '33.3%', '33.3%'],
                    body: lfTable
                },
            });

        }
        if (data['logframework'].length > 0
            && Object.keys(data['monitoringPlan']['data']).length > 0
            && Object.keys(data['monitoringPlan']['indicators']).length > 0
        ) {
            let PMPData = this.parsePMP(data['logframework'], data['monitoringPlan'], this.parsePMPData);
            let pmpTable = this.makeTablePMP(PMPData);

            this.docdefinition.content.push({
                text: `${i18n.t('Project Monitoring Plan')}`,
                style: ['header2'],
                pageBreak: 'before'
            });
            if (Object.keys(PMPData).length > 0) {
                this.docdefinition.content.push({
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['50%', '20%', '20%', '*10%'],
                        body: pmpTable
                    }
                });
            }
        }

        if (data['logframework'].length > 0
            && Object.keys(data['timeline']).length > 0
        ) {
            let Ptdata = this.parsePTData(data['timeline'], data['logframework']);
            let ptTable = this.makeTablePT(Ptdata);

            this.docdefinition.content.push({
                text: `${i18n.t('Project Time Line')}`,
                style: ['header2'],
                pageBreak: 'before'
            });
            this.docdefinition.content.push({
                table: {
                    widths: ['30%', '30%', '40%'],
                    body: ptTable
                }
            });
        }
    }

    //parse PMP data
    parsePMPData(key, data, ind, parseChilldren) {
        let chilldrensArray = [];
        let Data = {};
        let temp={};
        Data['indicator'] = {};
        Object.keys(data).forEach(key1 => {
            (ind.filter(indicator => indicator.ID == key1)).forEach(value => {
                Data['indicator'][value.ID] = {};
                Data['indicator'][value.ID]['targerBaseValues'] = [];
                Data['indicator'][value.ID]['description'] = {};
                Data['indicator'][value.ID]['Frequency'] = {};
                Data['indicator'][value.ID]['description'] = value.Description;
                Data['indicator'][value.ID]['Frequency'] = value.Frequency;
                let childrens = parseChilldren(value.Children, parseChilldren, chilldrensArray, value.ID)
                Data['indicator'][value.ID]['childrens'] = childrens;
                chilldrensArray = []
                if (data[key1].All) {
                    Object.keys(data[key1]['All']).forEach(value2 => {
                        let multipleSubind = {}
                        Object.keys(data[key1]['All'][value2]).forEach(value3 => {
                            multipleSubind['subId'] = value2
                            multipleSubind[value3] = data[key1]['All'][value2][value3];
                        });
                        Data['indicator'][value.ID]['targerBaseValues'].push(multipleSubind)
                    });
                }
                else {
                    let subInd = {}
                    Object.keys(data[key1]).forEach(value4 => {
                        if (typeof data[key1][value4] === 'object' && data[key1][value4] !== null) {
                            let multipleSubind = {}
                            Object.keys(data[key1][value4]).forEach(subIndicators => {
                                multipleSubind['subId'] = value4
                                multipleSubind[subIndicators] = data[key1][value4][subIndicators]
                            })
                            Data['indicator'][value.ID]['targerBaseValues'].push(multipleSubind)
                        }
                        else{
                            if(value4=="target"){
                                subInd["target"] = data[key1][value4]
                            }
                            if(value4=="baseline"){
                                subInd["baseline"]=data[key1][value4]
                            }
                            subInd['subId'] = key1
                            if(Object.keys(subInd).length==3){
                            Data['indicator'][value.ID]['targerBaseValues'].push(subInd)
                            }
                        }
                    });
                }
            });
        });
        return Data;
    }

    //parse ProjectTimeline data
    parsePTData(pt, lf) {
        let ptData = {}
        let lfData = this.parseLogframeworkData(lf);
        Object.keys(lfData).forEach(key1 => {
            ptData[`R${key1} ${lfData[key1].description}`] = {};
            if (lfData[key1].description) {
                Object.keys(lfData[key1]).forEach(key2 => {
                    if (lfData[key1][key2].description) {
                        Object.keys(lfData[key1][key2]).forEach(key3 => {
                            if (lfData[key1][key2][key3].description) {
                                ptData[`R${key1} ${lfData[key1].description}`][`A${key1}.${key2}.${key3}.${lfData[key1][key2][key3]['description']}`] = {}
                                if (pt[lfData[key1].ID]) {
                                    ptData[`R${key1} ${lfData[key1].description}`][`A${key1}.${key2}.${key3}.${lfData[key1][key2][key3]['description']}`]['years'] = this.parsePTYear(lfData[key1][key2][key3]['ID'], pt[lfData[key1].ID])
                                } else {
                                    ptData[`R${key1} ${lfData[key1].description}`][`A${key1}.${key2}.${key3}.${lfData[key1][key2][key3]['description']}`]['years'] = []
                                }
                            }
                        })
                    }
                })
            }
        })
        return ptData
    }

    //parse PT years
    parsePTYear(id, pt) {
        let yearArray = []
        Object.keys(pt).forEach(key1 => {
            Object.keys(pt[key1]).forEach(key2 => {
                if (key2 == id) {
                    Object.keys(pt[key1][key2]).forEach(key3 => {
                        yearArray.push(pt[key1][key2][key3])
                    })
                }
            })
        })
        return yearArray
    }

    //parse monitoting plan

    parsePMP(data, data2, parsePMPData) {
        let result = {}
        Object.keys(data).forEach(key1 => {
            if (data2['data'][data[key1]['id']] && data2['indicators'][data[key1]['id']]) {
                result[data[key1]['description']] = {}
                result[data[key1]['description']] = parsePMPData(data[key1]['description'], data2['data'][data[key1]['id']], data2['indicators'][data[key1]['id']], this.parseChilldren)
            }
        })
        return result
    }

    //recursive function to get pmp chilldren
    parseChilldren(key, parseChilldren, chilldrensArray, Id) {
        if (Array.isArray(key)) {
            key.forEach(keys => {
                parseChilldren(keys.Children, parseChilldren, chilldrensArray, Id)
                if (keys.Description) {
                    chilldrensArray.push({ id: Id, description: keys.Description, subIndId: keys.ID })
                }
                else {
                    return null
                }
            })
            return chilldrensArray
        }
        else {
            return null
        }
    }

    parseLogframeworkData(data) {
        let LFdata = {}, Id = 0, sId = 0, sId2 = 0;
        data.forEach((data: any) => {
            if (Object.keys(data).includes('deliverables')) {
                Id = Id + 1;
                LFdata[Id] = {};
                LFdata[Id]['description'] = data['description'];
                LFdata[Id]['ID'] = data['id'];
                Object.keys(data['deliverables']).forEach((key2: string) => {
                    sId = sId + 1;
                    LFdata[Id][sId] = {};
                    LFdata[Id][sId]['description'] = data['deliverables'][key2]['description'];
                    LFdata[Id][sId]['ID'] = data['deliverables'][key2]['id'];
                    if (Object.keys(data['deliverables'][key2]).includes('activities')) {
                        Object.keys(data['deliverables'][key2]['activities']).forEach((key3: string) => {
                            sId2 = sId2 + 1;
                            LFdata[Id][sId][sId2] = {};
                            LFdata[Id][sId][sId2]['description'] = data['deliverables'][key2]['activities'][key3]['description'];
                            LFdata[Id][sId][sId2]['ID'] = data['deliverables'][key2]['activities'][key3]['id'];

                        });
                        sId2 = 0;
                    }
                });
                sId = 0;
            }
        });
        Id = 0;
        return LFdata;
    }

    //creates projecttimeline
    makeTablePT(data) {
        let tableData = []
        let insideTable = []
        let quaterData = []
        let quaters = []
        let quaterWidths = []
        let columns = []
        let quaterTableBody = []
        let stack = []
        let stackContainer = []
        let headers = [{ text: `${i18n.t('Results')}`, alignment: 'center' }, { text: `${i18n.t('Activities')}`, alignment: 'center' }, { text: `${i18n.t('Scheduler')}`, alignment: 'center' }]
        Object.keys(data).forEach(key1 => {
            insideTable.push({ text: `${i18n.t(key1)}` })
            Object.keys(data[key1]).forEach(key2 => {
                Object.keys(data[key1][key2]).forEach(key3 => {
                    let yearCount = 0
                    data[key1][key2][key3].forEach(year => {
                        let qCount = 0
                        yearCount = yearCount + 1
                        for(let quater=1;quater<=this.quaters;quater++){
                            qCount = qCount + 1
                            quaterWidths.push('*')
                            quaters.push({ text: `Q${qCount}`, alignment: 'center' })
                            if (year[quater] && year[quater]==true) {
                                quaterData.push({ text: "√", alignment: 'center' })
                            }
                           else if(year[quater] && year[quater]==false){
                                quaterData.push({ text: "" })
                            }
                            else{
                                quaterData.push({ text: "" })
                            }
                        }
                        quaterWidths.push('*')
                        quaters.unshift({ text: '' })
                        quaterData.unshift({ text: `Year${yearCount}`, alignment: 'center' })
                        quaterTableBody.push(quaters)
                        quaterTableBody.push(quaterData)
                        columns.push({ table: { widths: quaterWidths, body: quaterTableBody } })
                        stack.push({ columns: columns })
                        columns = []
                        quaterWidths = []
                        quaters = []
                        quaterData = []
                        quaterTableBody = []
                    })
                    stackContainer.push({ stack: stack })
                    stack = []
                })
                if (insideTable.length == 1) {
                    insideTable.push({ text: `${i18n.t(key2)}` }, { columns: stackContainer })
                }
                else {
                    insideTable.push({ text: "" }, { text: `${i18n.t(key2)}` }, { columns: stackContainer })
                }
                tableData.push(insideTable)
                stackContainer = []
                insideTable = []
            })
        })
        tableData.unshift(headers)
        return tableData;
    }

    //creating monitoring plan table
    makeTablePMP(data) {
        let tableData = []
        let insideTable = []
        tableData.push(['Indicators', 'Frequency', {text:`${i18n.t('Baseline')}`,alignment:'center'}, {text:`${i18n.t('Target')}`,alignment:'center'}])
        Object.keys(data).forEach(keys=>{
            insideTable.push({text:`${i18n.t(keys)}`},{text:""},{text:""},{text:""})
            tableData.push(insideTable);
            insideTable = [];
            Object.keys(data[keys]).forEach(key2 => {
                Object.keys(data[keys][key2]).forEach(key3 => {
                    insideTable.push({ text:`${i18n.t(data[keys][key2][key3].description)}`},{text:`${i18n.t(data[keys][key2][key3]['Frequency'])}`},{text:""},{text:""});
                    tableData.push(insideTable);
                    insideTable = [];
                    if ((data[keys][key2][key3]['childrens']!=null && data[keys][key2][key3]['childrens'].length>0) && data[keys][key2][key3]['targerBaseValues']  ) {
                        data[keys][key2][key3]['childrens'].forEach(value => {
                            if (key3 == value.id) {
                                insideTable.push({ text: `${i18n.t(value.description)}`},{text:""},{text:""},{text:""});
                                tableData.push(insideTable);
                                insideTable = [];
                            }
                            data[keys][key2][key3]['targerBaseValues'].forEach(values => {
                                if (values.subId == value.subIndId) {
                                    insideTable.push({text:""},{text:""},{text:`${i18n.t(values.baseline)}`,alignment:'center'},{text:`${i18n.t(values.target)}`,alignment:'center'})
                                    tableData.push(insideTable);
                                    insideTable = [];
                                }
                            })
                        })
                    }
                    else
                    {
                        data[keys][key2][key3]['targerBaseValues'].forEach(values => {
                            insideTable.push({text:""},{text:""},{text:`${i18n.t(values.baseline)}`,alignment:'center'},{text:`${i18n.t(values.target)}`,alignment:'center'})
                            tableData.push(insideTable);
                            insideTable = [];
                    })
                    
                }
                })
            })
        })
        return tableData;
    }


    //creating logframework table
    makeTable(data) {
        let tableData = []
        let insideTable = []
        var stack1 = []
        var stack2 = []
        let stack1Temp: any
        let stack2Temp: any

        tableData.push(['Results', 'Outputs', 'Activities'])
        for (let key1 in data) {
            insideTable.push({ text: `${'R'}${key1}  ${data[key1]['description']}`, alignment: '' })
            Object.keys(data[key1]).forEach(x => {

                if (insideTable.length == 0) {
                    insideTable.push({ text: '', alignment: '' })
                }
                if (data[key1][x].description) {
                    stack1.push({ text: `${'O'}${key1}.${x}   ${data[key1][x]['description']}`, alignment: '', margin: [0, 2] })
                    Object.keys(data[key1][x]).forEach(x2 => {
                        if (data[key1][x][x2].description) {
                            Object.keys(data[key1][x][x2]).forEach(x3 => {
                                if (x3 != 'ID') {
                                    stack2.push({ text: `${'A'}${key1}.${x}.${x2}  ${data[key1][x][x2][x3]}`, margin: [0, 2] })
                                }
                            })
                        }
                    })
                    insideTable.push({ stack: stack1 }, { stack: stack2 });
                    stack2 = [];
                    stack1 = [];
                    tableData.push(insideTable);
                }
                insideTable = [];
            })
        }
        return tableData;
    }


} 
